import {
  TIKTOK_REPORT_CONTENT_ROWS,
  TIKTOK_REPORT_PERFORMANCE_ROWS,
} from 'app/modules/analytics/modules/reports/constants/reportMetricRowDefinitions';
import PlatformReportPreviewSections from './PlatformReportPreviewSections';
import type { ReportProfilePreviewSectionsProps } from '../types/ReportProfilePreviewSectionsProps';

const TikTokReportPreviewSections = (
  props: ReportProfilePreviewSectionsProps,
) => (
  <PlatformReportPreviewSections
    {...props}
    config={{
      performanceRows: TIKTOK_REPORT_PERFORMANCE_ROWS,
      contentRows: TIKTOK_REPORT_CONTENT_ROWS,
    }}
  />
);

export default TikTokReportPreviewSections;
